module.exports = __webpack_public_path__ + "static/80-5ee1d73241f53c9bb56906f15d81df19.png";